import React, {useState, useEffect} from "react";
import {defineBlock} from "@smartfire/wordpress-react";

import style from "./block.module.scss";

import Logo from'../assets/logo.svg';
import {ReactComponent as Arrow} from'./arrow.svg';
import {ReactComponent as MailIcon} from "../assets/mail.svg";

function Block({menu, custom_settings, languages, activeLang}){
    const [showMenu, setShowMenu] = useState(false);
    const [showMenuDesktop, setShowMenuDesktop] = useState(false);
    const [displayContent,setDisplayContent] = useState(false)

    const showMenuClick = () => {
        setShowMenu(!showMenu);
    }

    useEffect(() => {
        if (showMenu) document.body.style.overflowY = 'hidden';
        else document.body.style.overflowY = 'auto';
    }, [showMenu]);

    return <div className={style.block}>
        <div class={style.header}>
            <div onClick={() => {showMenuClick(); setShowMenuDesktop(showMenuDesktop === 'menuBurger' ? false : 'menuBurger')} } className={`${style.burger} ${showMenu && showMenuDesktop === 'menuBurger' && style.active}`}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className={style.logo}>
                <a href={`/${activeLang === 'en' ? 'en' : ''}`}>
                    <img src={Logo} alt="logo" />
                </a>
            </div>
            <div className={style.contentMenu}>
                <div className={style.menu}>
                    <ul>
                    {menu && Object.values(menu).map((m, index) => (
                        <li key={index}>
                            <div className={style.firstLevelMenu}> 
                            {
                                m.classes && m.classes.includes('no-link') ? m.title : <a href={m.url}>{m.title}</a>
                            }
                            
                            </div>
                            <div className={`${style.contentSubMenu} ${m.children.length === 0 && style.disable}`}>
                                <ul className={index === 0 && style.threeCols}>
                                {m.children && m.children.length > 0 && Object.values(m.children).map((subMenu, i) => (
                                    <li key={i} className={`${style.subMenu} ${subMenu.children && style.col}`}>
                                        {subMenu.classes && !subMenu.classes.includes('no-link') ? <a href={subMenu.url}><Arrow />{subMenu.title} </a> : <>
                                        <div>{subMenu.title}</div>
                                        <ul>
                                            {subMenu.children && Object.values(subMenu.children).map((subSubMenu, i2) => (
                                                <li key={i2} className={style.subSubMenu}>
                                                    <a href={subSubMenu.url}><Arrow />{subSubMenu.title}</a>
                                                </li>
                                            ))}
                                        </ul></>}
                                    </li>
                                ))}
                                </ul>
                            </div>
                        </li>
                    ))}
                    </ul>
                </div>
                <div className={style.contact}>
                    <a href={`${activeLang === 'en' ? '/en' : ''}${custom_settings.url_contact}`}>
                        <div className={style.button}>
                            <MailIcon /><span>Contact</span>
                        </div>
                    </a>
                </div>
                <div className={style.lang}>
                    {languages && Object.values(languages).map((language, index) => (
                        <div key={index} className={style.col}>
                            <a href={language.url} className={language.active ? style.selected : ''}>
                                <img src={language.country_flag_url} alt={language.native_name}/>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        <div className={`${style.mobile} ${showMenu && showMenuDesktop === 'menuBurger' ? style.active : null}`}>
            <div className={style.menu}>
                <ul>
                {menu && Object.values(menu).map((m, index) => (
                    <li key={index}>
                        {!m.children ? <a href={m.url}>{m.title}</a> : <>
                        <div 
                            onClick={()=> {setDisplayContent((old) => old === index ? null : index);}}
                            className={`${style.title} ${displayContent === index ? style.open : style.close}`}>
                            {
                                m.classes && m.classes.includes('no-link') ? m.title : <a href={m.url}>{m.title}</a>
                            }
                        </div></>
                        }
                    </li>
                ))}
                </ul>
                <div className={style.lang}>
                    {languages && Object.values(languages).map((language, index) => (
                        <div key={index} className={style.col}>
                            <a href={language.url} className={language.active ? style.selected : ''}>
                                <img src={language.country_flag_url} alt={language.native_name}/>
                                {language.native_name}
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
}

export default defineBlock({
    Block, 
    setup: {
        title: "Header",
    }
});

